var modules_efc4e723 = {"container":"_t18dh8","container_video":"_2l4i9y","placeholder":"_lbgqm2","placeholder_side":"_hmq548","placeholder_tgbm7":"_1viidjh","placeholder_top":"_18h27so","placeholder_video":"_5vm5w1"};
import "../../../assets/nkARWym_.css";

export { modules_efc4e723 as default };
//# sourceMappingURL=styles.module.scss.js.map
